exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\n  padding: 0; }\n  .footer__row {\n    margin: 0; }\n    .footer__row--one {\n      border-top: 1px solid #1e3161;\n      background-color: #1e3161; }\n    .footer__row--two {\n      text-align: center;\n      font-size: .875em; }\n  .footer__partnerName {\n    margin: 1.25em 0;\n    font-size: 1.125rem;\n    text-transform: uppercase;\n    color: #1e3161;\n    letter-spacing: 3px; }\n  .footer__partnerPhone {\n    margin: 1.25em 0; }\n  .footer__copyright .partner-name {\n    text-transform: capitalize; }\n  .footer__termList {\n    list-style: none;\n    padding: 0; }\n  .footer__termItem {\n    display: inline-block;\n    margin: 0 3px; }\n  .footer__termLink {\n    font-size: .7rem;\n    font-weight: bold;\n    color: #1e3161; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/footer/main-footer.component.scss
// module id = ../../../../../src/app/footer/main-footer.component.scss
// module chunks = main